var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor_cargando"},[_c('div',{staticClass:"caja_spinner"},[_c('b-spinner',{attrs:{"type":"grow","label":"Spinning"}}),_c('h3',[_vm._v(_vm._s(_vm.titulo))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }